import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '../IconButton';
import useStyles from './styles';

import deleteBtn from '../../../../resources/delete-btn@1x.png';


const DeleteButton = ({ onClick }) => {
  const classes = useStyles();
  return (
    <IconButton
      source={deleteBtn}
      onClick={onClick}
      alt="edit"
      iconClass={classes.button}
    />
  );
};

DeleteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default DeleteButton;
